__turbopack_context__.v({
  "blogBreadcrumbBar": "Blog-module__TPTzJG__blogBreadcrumbBar",
  "blogCard": "Blog-module__TPTzJG__blogCard",
  "blogCardAuthor": "Blog-module__TPTzJG__blogCardAuthor",
  "blogCardAuthorLarge": "Blog-module__TPTzJG__blogCardAuthorLarge",
  "blogCardContent": "Blog-module__TPTzJG__blogCardContent",
  "blogCardContentLarge": "Blog-module__TPTzJG__blogCardContentLarge",
  "blogCardExcerpt": "Blog-module__TPTzJG__blogCardExcerpt",
  "blogCardExcerptLarge": "Blog-module__TPTzJG__blogCardExcerptLarge",
  "blogCardExcerptSmall": "Blog-module__TPTzJG__blogCardExcerptSmall",
  "blogCardImageInner": "Blog-module__TPTzJG__blogCardImageInner",
  "blogCardImageLarge": "Blog-module__TPTzJG__blogCardImageLarge",
  "blogCardImageSmall": "Blog-module__TPTzJG__blogCardImageSmall",
  "blogCardImageWrap": "Blog-module__TPTzJG__blogCardImageWrap",
  "blogCardLarge": "Blog-module__TPTzJG__blogCardLarge",
  "blogCardLink": "Blog-module__TPTzJG__blogCardLink",
  "blogCardMeta": "Blog-module__TPTzJG__blogCardMeta",
  "blogCardMetaLarge": "Blog-module__TPTzJG__blogCardMetaLarge",
  "blogCardMetaSmall": "Blog-module__TPTzJG__blogCardMetaSmall",
  "blogCardSmall": "Blog-module__TPTzJG__blogCardSmall",
  "blogCardTag": "Blog-module__TPTzJG__blogCardTag",
  "blogCardTagLarge": "Blog-module__TPTzJG__blogCardTagLarge",
  "blogCardTags": "Blog-module__TPTzJG__blogCardTags",
  "blogCardTagsLarge": "Blog-module__TPTzJG__blogCardTagsLarge",
  "blogCardTitle": "Blog-module__TPTzJG__blogCardTitle",
  "blogCardTitleLarge": "Blog-module__TPTzJG__blogCardTitleLarge",
  "blogCardTitleSmall": "Blog-module__TPTzJG__blogCardTitleSmall",
  "blogClearButton": "Blog-module__TPTzJG__blogClearButton",
  "blogContainer": "Blog-module__TPTzJG__blogContainer",
  "blogEmptyIcon": "Blog-module__TPTzJG__blogEmptyIcon",
  "blogEmptyState": "Blog-module__TPTzJG__blogEmptyState",
  "blogEmptyText": "Blog-module__TPTzJG__blogEmptyText",
  "blogEmptyTitle": "Blog-module__TPTzJG__blogEmptyTitle",
  "blogFeaturedGrid": "Blog-module__TPTzJG__blogFeaturedGrid",
  "blogHero": "Blog-module__TPTzJG__blogHero",
  "blogHeroInner": "Blog-module__TPTzJG__blogHeroInner",
  "blogHeroSubtitle": "Blog-module__TPTzJG__blogHeroSubtitle",
  "blogHeroTitle": "Blog-module__TPTzJG__blogHeroTitle",
  "blogListingPage": "Blog-module__TPTzJG__blogListingPage",
  "blogMainContent": "Blog-module__TPTzJG__blogMainContent",
  "blogPaginationWrap": "Blog-module__TPTzJG__blogPaginationWrap",
  "blogRegularGrid": "Blog-module__TPTzJG__blogRegularGrid",
  "blogRegularItem": "Blog-module__TPTzJG__blogRegularItem",
  "blogResultsInfo": "Blog-module__TPTzJG__blogResultsInfo",
  "faqItem": "Blog-module__TPTzJG__faqItem",
  "faqItemAnswer": "Blog-module__TPTzJG__faqItemAnswer",
  "faqItemHeader": "Blog-module__TPTzJG__faqItemHeader",
  "faqItemIcon": "Blog-module__TPTzJG__faqItemIcon",
  "faqItemIconExpanded": "Blog-module__TPTzJG__faqItemIconExpanded",
  "faqItemQuestion": "Blog-module__TPTzJG__faqItemQuestion",
  "faqSection": "Blog-module__TPTzJG__faqSection",
  "faqTitle": "Blog-module__TPTzJG__faqTitle",
  "otherPostsEmpty": "Blog-module__TPTzJG__otherPostsEmpty",
  "otherPostsGrid": "Blog-module__TPTzJG__otherPostsGrid",
  "otherPostsLoading": "Blog-module__TPTzJG__otherPostsLoading",
  "otherPostsSection": "Blog-module__TPTzJG__otherPostsSection",
  "otherPostsTitle": "Blog-module__TPTzJG__otherPostsTitle",
  "shareButton": "Blog-module__TPTzJG__shareButton",
  "shareButtonFacebook": "Blog-module__TPTzJG__shareButtonFacebook",
  "shareButtonLinkedin": "Blog-module__TPTzJG__shareButtonLinkedin",
  "shareButtonTwitter": "Blog-module__TPTzJG__shareButtonTwitter",
  "shareButtons": "Blog-module__TPTzJG__shareButtons",
  "shareContainer": "Blog-module__TPTzJG__shareContainer",
  "shareLabel": "Blog-module__TPTzJG__shareLabel",
});
